export const COOKIE_CONSENT_NAME = 'CookieConsent';
export const GTM_COOKIE_NAME = 'gatsby-gdpr-google-tagmanager';
export const CLARITY_COOKIE_NAME = 'gatsby-gdpr-clarity';
export const COOKIE_EXPIRATION_DAYS_EU = 30;
export const COOKIE_EXPIRATION_DAYS = 1;
export const COOKIE_ACCEPT = 'true';
export const COOKIE_DECLINE = 'false';
export const UTM_DATE = 'utm_date';
export const UTM_ID = 'utm_id';
export const UTM_CAMPAIGN = 'utm_campaign';
